import request from '@/utils/request'

export function exportTenant(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}
// 租赁中个人租赁订单导出
export function exportPersonal(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/leasing/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

// 租赁中企业主租赁订单导出
export function exportEnterprisePrimary(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/leasing/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

// 租赁中企业主租赁订单导出
export function exportEnterpriseChild(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/sub/leasing/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

/* 客户管理导出 */
export function exportCustomer(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/customer/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

/* 车辆证照管理  */
export function exportLicenseState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/routines/licenseState/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}
/* 车辆违章记录 */
export function exportViolation(data = {}) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

export function exportViolationManage(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carLicenseManage/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}
/* 违章记录 */
export function exportViolationDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/routines/violation/detail/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}
/* 车险管理 */
export function exportInsurance(data = {}) {
  return request({
    url: '/admin/v1/vehicle/routines/insurance/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}
/* 保单管理 */
export function exportInsuranceDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/routines/insuranceDetail/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}
/* 维保管理 */
export function exportMaintenance(data = {}) {
  return request({
    url: '/admin/v1/vehicle/routines/maintenance/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}
/* 事故管理 */
export function exportAccident(data = {}) {
  return request({
    url: '/admin/v1/vehicle/routines/accident/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}
/* 财务-应收管理 */
export function exportReceivable(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

/* 财务-收款单管理 */
export function exportReceivableOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

/* 财务-应付管理 */
export function exportPayment(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

/* 财务-付款单管理 */
export function exportPaymentOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/bill/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

/* 车辆-车辆库存管理 */
export function exportCarList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/vehicle/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

/* 车辆-出入库列表 */
export function exportCarOutInList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

/* 工作台-数据看板 */
export function exportDataBoard(data = {}) {
  return request({
    url: '/admin/v1/vehicle/data/board/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

// 企业租赁订单导出
export function exportLeaseOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}
// 财务-扣款计划管理
export function exportAccruedPlan(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/accruedPlan/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}
// 财务-退款单管理
export function exportRefundOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/refund/receipt/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

/**
 * @apiName 款项变更记录导出
 * @aiUrl
 */
export function exportAccruedChange(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/accruedChange/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

// 企业租赁子订单导出
export function exportLeaseOrderSub(data = {}) {
  return request({
    url: '/admin/v1/vehicle/lease/order/sub/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}
// 催收-逾期明细导出
export function exportOverdue(data = {}) {
  return request({
    url: '/admin/v1/vehicle/debt/overdue/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

// 催收-逾期明细异步导出
export function exportDownloadFile(data = {}) {
  return request({
    url: '/admin/v1/vehicle/async/export/downloadFile',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

// 催收-预提醒明细导出
export function exportRemind(data = {}) {
  return request({
    url: '/admin/v1/vehicle/debt/remind/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

// 催收-逾期汇总表导出
export function exportOverDueSummary(data = {}) {
  return request({
    url: '/admin/v1/vehicle/debt/overdueSummary/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

// 催收-逾期汇总详情导出
export function exportOverDueDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/debt/overdueDetail/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}
// 下载错误信息
export function exportUploadTask(data = {}) {
  return request({
    url: '/admin/v1/vehicle/uploadTask/download',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}
// 数据报表-订单信息
export function exportBoardOrder(data) {
  return request({
    url: '/admin/v1/vehicle/data/board/order/export',
    responseType: 'blob',
    method: 'post',
    data,
  })
}
// 数据报表- 经营情况
export function exportBoardOperation(data) {
  return request({
    url: '/admin/v1/vehicle/data/board/operation/export',
    responseType: 'blob',
    method: 'post',
    data,
  })
}
// 数据报表-经营分析
export function exportBoardManage(data) {
  return request({
    url: '/admin/v1/vehicle/data/board/manage/export',
    responseType: 'blob',
    method: 'post',
    data,
  })
}
// 数据报表-财务信息
export function exportBoardFinance(data) {
  return request({
    url: '/admin/v1/vehicle/data/board/finance/export',
    responseType: 'blob',
    method: 'post',
    data,
  })
}
// 车辆导出
export function exportBoardCar(data) {
  return request({
    url: '/admin/v1/vehicle/data/board/car/export',
    responseType: 'blob',
    method: 'post',
    data,
  })
}

// 客户还车-列表
export function exportReturnCarOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/return/lease/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

// 导出强制收车数据
export function exportRecallCarList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/recall/car/order/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

// 车辆/车辆调拨/调出任务
export function exportVehicleTransfer(data = {}) {
  return request({
    url: '/admin/v1/vehicle/transferTask/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}

// 车辆/车辆调拨/详情/车辆导出
export function exportVehicleTransferCars(data = {}) {
  return request({
    url: '/admin/v1/vehicle/transferTask/car/export',
    method: 'POST',
    data,
    responseType: 'blob',
    isExport: true,
  })
}
// 导出审批明细接口
export function exportApprovalDetail(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/detail/export',
    method: 'POST',
    responseType: 'blob',
    data,
  })
}

// 采购主订单导出数据
export function exportPurchaseOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/purchase/order/export',
    method: 'POST',
    responseType: 'blob',
    data,
  })
}

// 采购子订单导出数据
export function exportPurchaseSonOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/purchase/sub/order/export',
    method: 'POST',
    responseType: 'blob',
    data,
  })
}

// 线索管理列表 导出
export function exportSalesLeadList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/clue/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}
// 商品库导出数据
export function exportCommodity(data = {}) {
  return request({
    url: '/admin/v1/vehicle/commerce/template/export',
    method: 'POST',
    responseType: 'blob',
    data,
  })
}


/** 审批流导出 */
export function exportApprovalList(data = {}) {
  return request({
    url: '/admin/v1/approval/flow/export',
    method: 'POST',
    responseType: 'blob',
    data,
  })
}

export function exportBusinessManageList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carResource/message/export',
    responseType: 'blob',
    method: 'post',
    isExport: true,
    data,
  })
}


// E签宝-使用明细导出
export function exportChargeRecordList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/org/chargeRecordList/export',
    responseType: 'blob',
    method: 'POST',
    isExport: true,
    data,
  })
}

/**
 * 导出历史页面，获取下载链接地址
 * @param {*} data
 * @param {string} objectName 文件私有地址
 * @returns
 */
export function getDownloadUrl(data = {}) {
  return request({
    url: '/admin/v1/exportCenter/exportRecord/url',
    method: 'post',
    data,
  })
}

/**
 * 导出历史页面，获取导出记录列表
 * @param {*} data
 * @param {number} startTime 申请时间开始时间
 * @param {number} endTime 申请时间结束时间
 * @returns
 */
export function exportRecordList(data = {}) {
  return request({
    url: '/admin/v1/exportCenter/userIntegral/exportRecord',
    method: 'post',
    data,
  })
}

/**
 * 查询历史导入记录
 * @param {*} data
 * @param {array} bizIdList 批量导入的服务key，车辆列表 - BATCH_CAR_INFO_IMPORT
 * @param {number} pageNum 页码
 * @param {number} pageSize 每页条数
 *
 */
export function getHistoryRecordWithTenantId(data = {}) {
  return request({
    url: '/admin/v1/opsx/batchimport/getHistoryRecordWithTenantId',
    method: 'post',
    data,
  })
}

/**
 * 导出付款明细 https://mock-test.cheweijia.com/project/10282/interface/api/492447
 * @param {Object} params - 查询参数
 * @param {number} params.billId - 账单ID
 * @param {string} params.dm - 账单月份
 * @param {number} params.amountType - 费用类型 (0: 基础技术服务费, 1: 支付宝支付技术服务费)
 * @param {string} params.startDate - 付款开始时间：yyy-mm-dd hh:mm:ss
 * @param {string} params.endDate - 付款结束时间：yyy-mm-dd hh:mm:ss
 * @param {string} params.condition - 查询条件
 */
export function exportPaymentDetail({
  billId,
  dm,
  amountType,
  startDate,
  endDate,
  condition,
}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/finance/tech/deductionDetailsExport',
    method: 'post',
    responseType: 'blob',
    isExport: true,
    data: {
      billId,
      dm,
      amountType,
      startDate,
      endDate,
      condition,
    },
  })
}

// 获取异步导出字段
export function getExportColumns(template) {
  return request({
    url: '/admin/v1/exportCenter/header/list',
    method: 'post',
    data: { template },
  })
}
